const formatDateSolicitation = (dateString) => {
  if (!dateString) return "Data não disponível";

  const date = new Intl.DateTimeFormat("pt-BR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).format(new Date(dateString));
  
  const formattedDate = date
  .replace(/\s+/g, '')
  .split(',')
  .map((part, index) => index === 0 ? part : part.split(':').slice(0, 2).join(':'))

  return formattedDate;
};

export default formatDateSolicitation;